import * as React from "react";
import { RolePopup } from "lib/components/RolePopup";

import I18n from "lib/I18n";

export function App() {
  const popoverMessage = (
    <b>{I18n.t("role_description_viewer.messages.description")}</b>
  );

  return (
    <span>
      <RolePopup prefixElement={popoverMessage} placement="bottom" />
    </span>
  );
}
